import { ApiDataResultSuccess } from "@advosys/component-app-server-client-js";
import { MockDataBuilder } from "@advosys/component-app-server-client-js-mock";
import { matterTypes } from "../data/matter-type-v2";
import { preparedInvoices } from "../data/prepared-invoice-v2";
export class MobilityMockDataBuilder extends MockDataBuilder {
    dynamicPreparedInvoicesForApproval = () => {
        this.data.finance.preparedInvoiceV2.getPreparedInvoicesForApprovalAsync = async () => {
            return new ApiDataResultSuccess(preparedInvoices);
        };
        return this;
    };
    matterTypes = () => {
        this.data.matter.matterV2.getMatterTypesAsync = async () => new ApiDataResultSuccess(matterTypes);
        return this;
    };
    matterPenneoFormIsValid = () => {
        this.data.company.companyV2.getPenneoFormValidAsync = async () => new ApiDataResultSuccess(true);
        return this;
    };
}
